import { NgModule } from '@angular/core';
import { GetListItemTextPipe } from './descriptions/get-list-item-text';

@NgModule({
  declarations: [GetListItemTextPipe],
  imports: [],
  exports: [GetListItemTextPipe],
})
export class PipesModule {}
